<template>
  <div>
    <van-cell
      class="header"
      :title="`累计补款：${totalAmount}元`"
      title-class="name"
    />
    <long-list
      class="info-panel"
      :api-method="getData"
      :response-handler="dataHandler"
    >
      <template #default="{list}">
        <mtd-table
          v-if="list&&list.length"
          :data="list"
          bordered
          striped
        >
          <mtd-table-column
            v-for="item in columns"
            :key="item.label"
            v-bind="item"
          />
        </mtd-table>
        <NoBillTips
          v-else
          msg="暂无数据"
        />
      </template>
    </long-list>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NoBillTips from '@/components/NoBillTips';
import BillApi from '@/api/bill';
import { formatAmount, formatTableColumns } from '@/util/filter';

export default {
  name: 'Inventory',
  components: { NoBillTips },
  data() {
    return {
      totalAmount: formatAmount(0),
      columns: formatTableColumns([
        {
          label: '设备SN',
          prop: 'cabinSn',
        },
        {
          label: '金额',
          formatter: (row) => formatAmount(row.amount),
        },
        {
          label: '日期',
          prop: 'cutDay',
        },
      ]),
    };
  },
  computed: {
    ...mapState('billModule', {
      billInfo(state) {
        if (this.$route.query.from === 'billed') {
          return state.currentBilledInfo;
        } else {
          return state.currentUnbilledInfo;
        }
      },
    }),
    ...mapState('billModule', ['settleUnitIdList']),
  },
  methods: {
    getData(pageNum, pageSize) {
      const { cutMonth, customerId } = this.billInfo;
      const settleUnitIdList = this.settleUnitIdList;
      const params = {
        customerId,
        settleUnitIdList,
        cutMonth,
        pageNum,
        pageSize,
      };
      return BillApi.getInventoryAddBill(params);
    },
    dataHandler(res) {
      const data = res.data || {};
      this.totalAmount = formatAmount(data.totalAmount);
      const { content = [], ...other } = data.assetInventoryBills || {};
      return { list: content, ...other };
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: none;
  .name{
    font-weight: bold;
    font-size: 30px;
    color: black;
    text-align: left;
  }
  .value {
    @extend .name;
    font-weight: normal;
    color: blue;
    text-align: right;
  }
}

</style>
